import { ccv, crv, cva } from '@/styled-system/css';

export const anchorRecipe = cva({
  base: {
    textDecoration: {
      base: 'underline',
    },
    textStyle: 'inherit',
    color: {
      base: 'text.link.default',
      _notDisabled: {
        _hover: 'text.link.hover',
        _active: 'text.link.pressed',
        _focusVisible: 'text.link.hover',
        _visited: 'text.link.last-visited',
      },
    },
    cursor: {
      base: 'pointer',
      _disabled: 'default',
    },
    opacity: {
      _disabled: 'disabled',
    },
    focusOutline: true,
  },
  variants: {
    ...crv('onImpact', {
      true: {
        color: {
          base: 'text.onImpact.link.default',
        },
        textDecoration: {
          _hover: 'none',
        },
      },
      false: {},
    }),
  },
  compoundVariants: [
    ...ccv({
      onImpact: true,
      css: {
        color: {
          _notDisabled: {
            _hover: 'text.onImpact.link.hover',
            _active: 'Anchor.onImpact.pressed',
            _focusVisible: 'text.onImpact.link.hover',
            _visited: 'text.onImpact.link.last-visited',
          },
        },
      },
    }),
  ],
});
